// @avantia common-code
import * as dateFns from 'date-fns';

export type HpDatePart = 'day' | 'month' | 'year' | 'date';

export enum HpMonth {
  January = 0,
  February = 1,
  March = 2,
  April = 3,
  May = 4,
  June = 5,
  July = 6,
  August = 7,
  September = 8,
  October = 9,
  November = 10,
  December = 11
}

// Returns the amount of days in a month and year taking into account leap years.
export function getMonthDays(date: Date): number {
  return dateFns.getDaysInMonth(date);
}

export const monthArray: { name: string; key: HpMonth }[] = [
  { name: 'January', key: HpMonth.January },
  { name: 'February', key: HpMonth.February },
  { name: 'March', key: HpMonth.March },
  { name: 'April', key: HpMonth.April },
  { name: 'May', key: HpMonth.May },
  { name: 'June', key: HpMonth.June },
  { name: 'July', key: HpMonth.July },
  { name: 'August', key: HpMonth.August },
  { name: 'September', key: HpMonth.September },
  { name: 'October', key: HpMonth.October },
  { name: 'November', key: HpMonth.November },
  { name: 'December', key: HpMonth.December }
];

export function isSameDay(date1: Date | string, date2: Date | string): boolean {
  return getDayDifference(date1, date2) === 'same';
}

export function isEarlierDay(date1: Date | string, date2: Date | string): boolean {
  return getDayDifference(date1, date2) === 'before';
}

export function formatDate(date: Date | string, format: string): string {
  const dt: Date = typeof date === 'string' ? new Date(date) : date;
  return dateFns.format(dt, format.replace(/Y/g, 'y').replace(/D/g, 'd'));
}

export function formatDateWithoutTZ(date: string, format: string): string {
  const dateWithoutTZ = date.replace('Z', '');
  const dt: Date = new Date(dateWithoutTZ);
  return dateFns.format(dt, format.replace(/Y/g, 'y').replace(/D/g, 'd'));
}

export function setDatePart(
  date: Date | string,
  partToUpdate: 'month' | 'year' | 'date',
  value: number | string
): Date {
  let newDate = new Date(date);
  const part = typeof value === 'string' ? parseInt(value) : value;
  switch (partToUpdate) {
    case 'date':
      newDate = dateFns.setDate(newDate, part);
      break;
    case 'month':
      newDate = dateFns.setMonth(newDate, part);
      break;
    case 'year':
      newDate = dateFns.setYear(newDate, part);
      break;
  }

  return newDate;
}

function getDayDifference(date1: Date | string, date2: Date | string): 'same' | 'before' | 'after' {
  const d1 = dateFns.startOfDay(new Date(date1));
  const d2 = dateFns.startOfDay(new Date(date2));
  const diff = dateFns.differenceInDays(d1, d2);

  if (diff === 0) {
    return 'same';
  }

  if (d1 < d2) {
    return 'before';
  }

  return 'after';
}
